<script lang="ts">
  export let background = '#fff';
  export let classes = '';
  export let style = '';
</script>

<section class={classes} style="background-color:{background};{style}">
  <slot />
</section>

<style>
  section {
    padding: 80px 0;
  }
  section.p-top-0 {
    padding-top: 0;
  }
  section.p-sm {
    padding: 20px 0;
  }
  @media screen and (max-width: 1200px) {
    section {
      padding: 25px;
    }
  }
  @media screen and (max-width: 767px) {
    section {
      padding: 25px;
    }
    section.p-sm {
      padding: 10px 0;
    }
  }
</style>
